import { ButtonBase, Stack, Typography } from '@mui/material'
import { Icons } from 'utoniq-ui'

import { Maybe } from '@/clients/utoniq-core/schema'
import { useMessage, useTranslation } from '@/core'

/**
 * @description
 * 仮想通貨ウォレットアドレス表示
 * - アドレスは中心部省略表示
 * - クリックでアドレス全文ClipBoardコピー
 */
export const CryptoWalletAddress = ({
  cryptoWalletAddress,
  variant = 'subtitle2',
  color = 'text.secondary',
}: {
  cryptoWalletAddress?: Maybe<string>
  variant?: 'subtitle1' | 'subtitle2'
  color?: 'text.secondary'
}) => {
  const { t } = useTranslation('wallet')
  const { showMessage } = useMessage()

  const truncateAddress = (address: string) => {
    const start = address.substr(0, 8)
    const end = address.substr(-6)

    return start + '...' + end
  }

  const iconSize = {
    subtitle1: {
      height: 16,
      width: 16,
    },
    subtitle2: {
      height: 12,
      width: 12,
    },
  }

  return (
    <Stack direction="row" alignItems="center">
      <ButtonBase
        onClick={e => {
          e.stopPropagation()
          e.preventDefault()
          navigator.clipboard
            .writeText(cryptoWalletAddress ?? '')
            .then(() => showMessage(t('cryptoWalletAddressCopied'), 'success'))
        }}
        /**
         * Unaffected by parent component ripple
         */
        onTouchStart={e => e.stopPropagation()}
        onMouseDown={e => e.stopPropagation()}
      >
        <Typography variant={variant} color={color}>
          {cryptoWalletAddress && truncateAddress(cryptoWalletAddress)}
        </Typography>
        <Icons.Copy
          sx={{ alignSelf: 'center', ml: 1, ...iconSize[variant] }}
          onClick={e => {
            e.stopPropagation()
            e.preventDefault()
            navigator.clipboard.writeText(cryptoWalletAddress ?? '')
          }}
        />
      </ButtonBase>
    </Stack>
  )
}
